import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'ExamineStatus',
  props: {
    state: {
      type: Number
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");
      return _openBlock(), _createElementBlock("span", null, [__props.state === 0 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 0,
        type: "success",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("已通过", -1)]))]),
        _: 1
      })) : __props.state === 1 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 1,
        type: "danger",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("未通过", -1)]))]),
        _: 1
      })) : __props.state === 2 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 2,
        type: "warning",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("待审核", -1)]))]),
        _: 1
      })) : __props.state === 3 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 3,
        type: "info",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("待认领", -1)]))]),
        _: 1
      })) : __props.state === 4 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 4,
        type: "info",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("待提交", -1)]))]),
        _: 1
      })) : __props.state === 5 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 5,
        type: "success"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("结束", -1)]))]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_tag, {
        key: 6,
        type: "info"
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("未知状态", -1)]))]),
        _: 1
      }))]);
    };
  }
};